import * as React from "react";
import { RouteComponentProps } from "react-router";
import { withRouter } from "react-router-dom";
import {
  Input,
  Button,
  Dropdown,
  DropdownOption,
} from "@abb/abb-common-ux-react";

import SubmitHeader from "../shared/SubmitHeader";

import history from "../../utilities/History";

import propertyActions from "../../flux/actions/PropertyActions";
import propertyTypeActions from "../../flux/actions/PropertyTypeActions";
import propertyFormStore from "../../flux/stores/property/FormStore";
import propertyTypeListStore from "../../flux/stores/propertyType/ListStore";
import propertyListStore from "../../flux/stores/property/ListStore";
import propertyAttributeListStore from "../../flux/stores/propertyAttribute/ListStore";

import IPropertyFormData, {
  PropertyFormData,
  IPropertyAttributeData,
} from "../../models/property/PropertyFormData";
import navigationHeaderActions from "../../flux/actions/NavigationHeaderActions";

import * as CONSTANTS from "../../utilities/Constants";
import * as ICONCONSTANTS from "../../utilities/IconConstants";
import submitHeaderActions from "../../flux/actions/SubmitHeaderActions";
import IFormComponent from "../../models/shared/FormComponent";
import triggerNotifications from "../../utilities/TriggerNotifications";
import { IPropertyViewData } from "../../models/property/PropertyViewData";
import IPropertyAttribute from "../../models/propertyAttribute/PropertyAttributeData";
import propertyAttributeActions from "../../flux/actions/PropertyAttributeActions";
import IPropertyCalculatedData from "../../models/property/PropertyCalculatedData";
import IPropertyType from "../../models/propertyType/PropertyTypeData";
import { IVariableData } from "../../models/property/CalculatedPropertyViewData";
import { Translation } from "react-i18next";
import loadingActions from "../../flux/actions/LoadingActions";
import formLoadingIndicatorStore from "../../flux/stores/shared/FormLoadingStore";
import { CHANGE_EVENT } from "../../utilities/Constants";
import i18next from "i18next";

// Todo: Understand
type PropsType = RouteComponentProps & {};
// End

interface IFormState {
  propertyFormData: IPropertyFormData;
  propertyDropdownList: any[];
  propertyCodeIdDropdownList: any[];
  propertyAttributeDropdownList: any[];
  propertyTypes: any[];
  isFormula: boolean;
  isCalculated: boolean;
  selectedCodeId: any[];
  selectedProperty: any[];
  selectedPropertyAttribute: any[];
  propertyTypesdropdownList: any[];
  selectedPropertyType: any[];
  oldData: IPropertyFormData;
  formLoading: boolean;
  customIdError: boolean;
  nameError: boolean;
}

class Form
  extends React.Component<PropsType, IFormState>
  implements IFormComponent
{
  _mount: boolean;
  _isReload: boolean;
  _id: string;
  _messages: string[];
  private _propertyDropdownList: IPropertyViewData[] = [];
  private _propertyAttributeDropdownList: IPropertyAttributeData[] = [];
  private _validId: boolean;
  private _validDecimal: boolean = true;
  private _validationStatus: { valid: boolean; text: any } = {
    valid: true,
    text: undefined,
  };
  private _validName: boolean = false;

  constructor(props: PropsType) {
    super(props);
    const pushStateData = this.props.location.state as IPropertyFormData;

    this.state = {
      propertyFormData: pushStateData,
      propertyDropdownList: [],
      propertyCodeIdDropdownList: [],
      propertyAttributeDropdownList: [],
      propertyTypes: [],
      isFormula: false,
      isCalculated: false,
      selectedCodeId: [],
      selectedProperty: [],
      selectedPropertyAttribute: [],
      propertyTypesdropdownList: [],
      selectedPropertyType: [],
      oldData: { ...pushStateData },
      formLoading: false,
      customIdError: false,
      nameError: false,
    };
    this._mount = false;
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;

    propertyTypeActions
      .getAll()
      .then(() => {
        const propertyTypesdropdownList: any[] = [];
        this.state.propertyTypes.forEach((element: IPropertyViewData) => {
          propertyTypesdropdownList.push({
            label: element.name,
            value: element.id,
          });
        });
        this.setState(
          {
            propertyTypesdropdownList,
          },
          () => this.forceUpdate()
        );
      })
      .catch((error) => {
        triggerNotifications.errors(error.message, error.data).then();
      });

    if (this.state.propertyFormData?.isEditMode) {
      submitHeaderActions
        .update({
          moduleName: CONSTANTS.MODULE_PROPERTY,
          isSubmitDisabled: false,
        })
        .then();
    }

    if (this._mount) {
      navigationHeaderActions
        .updateHeader({
          name: CONSTANTS.MODULE_PROPERTY,
          action: this.state.propertyFormData?.isEditMode
            ? CONSTANTS.EDIT
            : CONSTANTS.CREATE,
          icon: this.state.propertyFormData?.isEditMode
            ? ICONCONSTANTS.ABB_EDIT
            : ICONCONSTANTS.ABB_PLUS,
          goBackUrl: CONSTANTS.PROPERTY_INDEX_URL,
          isGoBackWithData: false,
          goBackData: {},
          isDataChanged: false,
        })
        .then();
    }

    propertyTypeListStore.once(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        const propertyType = state.propertyTypeData.filter(
          (x: any) => x.name !== "Measured"
        );
        this.setState({ propertyTypes: propertyType });
      }
    });

    propertyListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._propertyDropdownList = state.propertyDataList.result
        ? state.propertyDataList.result
        : state.propertyDataList;
    });

    propertyAttributeListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._propertyAttributeDropdownList = state.propertyAttributeData;
    });

    propertyFormStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._isReload = false;
        this._id = state.propertyId;
        this._messages = state.message;
      }
    });

    if (this.state.propertyFormData?.isEditMode) {
      this.setState({
        selectedPropertyType: [
          {
            label: this.state.propertyFormData.type,
            value: this.state.propertyFormData.typeId,
          },
        ],
      });

      if (this.state.propertyFormData.formulaDetails !== null) {
        const variableData: IPropertyCalculatedData[] = [];
        (this.state.propertyFormData.formulaDetails.variables || []).map(
          (data: any) => {
            const property = [
              {
                label: data.property.name,
                value: data.property.id,
              },
            ];
            const propertyAttribute = [
              {
                label: data.attribute.name,
                value: data.attribute.id,
              },
            ];
            const formulaDetails = {
              propertyId: data.property.id,
              property: property,
              propertyAttributeId: data.attribute.id,
              propertyAttribute: propertyAttribute,
              codeId: data.property.customId,
              variable: data.variable,
            };
            variableData.push(formulaDetails);
          }
        );
        this.setState(
          {
            isFormula: true,
            isCalculated: true,
            propertyFormData: {
              ...this.state.propertyFormData,
              formula: this.state.propertyFormData.formulaDetails.formula,
              formulaVariables: variableData,
            },
          },
          () => {
            this.onCalculatedSaveClick();
            this.forceUpdate();
          }
        );
      }
    }

    formLoadingIndicatorStore.on(CHANGE_EVENT, (state) => {
      if (this._mount) {
        submitHeaderActions
          .update({
            moduleName: CONSTANTS.MODULE_PROPERTY,
            isSubmitDisabled: state.data,
            isLoading: state.data,
          })
          .then();
      }
    });
  }

  componentDidUpdate() {
    if (
      JSON.stringify(this.state.oldData) !==
      JSON.stringify(this.state.propertyFormData)
    ) {
      navigationHeaderActions
        .updateHeader({
          name: CONSTANTS.MODULE_PROPERTY,
          action: this.state.propertyFormData?.isEditMode
            ? CONSTANTS.EDIT
            : CONSTANTS.CREATE,
          icon: this.state.propertyFormData?.isEditMode
            ? ICONCONSTANTS.ABB_EDIT
            : ICONCONSTANTS.ABB_PLUS,
          goBackUrl: CONSTANTS.PROPERTY_INDEX_URL,
          isGoBackWithData: false,
          goBackData: {},
          isDataChanged: true,
        })
        .then();
    }
  }

  private typeChangeHandler = (e: any) => {
    const propertyFormData = this.state.propertyFormData;
    propertyFormData.typeId = e[0].value;
    this.setState(
      {
        selectedPropertyType: [
          {
            label: e[0].label,
            value: e[0].value,
          },
        ],
        propertyFormData,
      },
      this.validate
    );
    if (e[0].value === CONSTANTS.CALCULATEDID) {
      this.setState({
        isFormula: true,
      });
    } else {
      this.setState({
        isFormula: false,
      });
    }
  };

  private setCustomId = (value: string) => {
    if (value.trim() && /^[0-9]+$/i.test(value)) {
      const propertyFormData = this.state.propertyFormData;
      propertyFormData.customId = value;
      this.setState(
        {
          customIdError: false,
          propertyFormData,
        },
        this.validate
      );
    } else {
      const propertyFormData = this.state.propertyFormData;
      propertyFormData.customId = value;
      this.setState(
        {
          customIdError: true,
          propertyFormData,
        },
        this.validate
      );
    }
  };

  private setName = (value: string) => {
    var rgFile = CONSTANTS.COMMONREGEXP;
    if (value.trim() && !rgFile.test(value)) {
      const propertyFormData = this.state.propertyFormData;
      propertyFormData.name =
        value.length > 1 ? value : value.replace(/\s/g, "");
      this.setState(
        {
          nameError: false,
          propertyFormData,
        },
        this.validate
      );
    } else {
      const propertyFormData = this.state.propertyFormData;
      propertyFormData.name =
        value.length > 1 ? value : value.replace(/\s/g, "");
      this.setState(
        {
          nameError: true,
          propertyFormData,
        },
        this.validate
      );
    }
  };

  private setDescription = (value: string) => {
    const propertyFormData = this.state.propertyFormData;
    propertyFormData.description = value;
    this.setState(
      {
        propertyFormData,
      },
      this.validate
    );
  };

  private setUnits = (value: string) => {
    const propertyFormData = this.state.propertyFormData;
    propertyFormData.unit = value;
    this.setState(
      {
        propertyFormData,
      },
      this.validate
    );
  };

  private setDecimals = (value: string) => {
    let isValid = value === "" || Number(value) <= 5 ? true : false;
    if(isValid){
    const propertyFormData = this.state.propertyFormData;
    propertyFormData.decimals = value;
    this.setState(
      {
        propertyFormData,
      },
      this.validate
    );
    } else {
      triggerNotifications.error(i18next.t("Decimal should be less than 6.")).then();
    }
  };

  private setFormula = (value: string) => {
    if (value !== "") {
      this.setState(
        {
          propertyFormData: { ...this.state.propertyFormData, formula: value },
        },
        () => {
          this.validate();
          try {
            const itemsList = this.state.propertyFormData.formula.match(
              CONSTANTS.CALCREGEXP
            );
            const items = itemsList.filter(
              (item: any, key: number) => itemsList.indexOf(item) === key
            );
            if (items !== undefined && items !== null) {
              const formulaVariables: IPropertyCalculatedData[] = [];

              items.forEach((item: string, index: number) => {
                formulaVariables.push({
                  propertyId: "",
                  property: [],
                  propertyAttributeId: "",
                  propertyAttribute: [],
                  codeId: "",
                  variable: item,
                });
              });
              this.setState(
                {
                  propertyFormData: {
                    ...this.state.propertyFormData,
                    formulaVariables,
                  },
                },
                this.validate
              );
            } else {
              const formulaVariables: IPropertyCalculatedData[] = [];

              this.setState({
                propertyFormData: {
                  ...this.state.propertyFormData,
                  formulaVariables,
                },
              });
            }
          } catch (error) {
            console.log("error", error);
          }
        }
      );
    } else if (value === "") {
      this.setState(
        {
          propertyFormData: { ...this.state.propertyFormData, formula: value },
        },
        this.validate
      );
    }
  };

  private onCalculatedSaveClick = () => {
    propertyActions
      .checkFormula(this.state.propertyFormData.formula.toString().trim())
      .then((response: boolean) => {
        if (!response) {
          propertyActions
            .getAll(
              1,
              CONSTANTS.PAGE_SIZE_ALL,
              CONSTANTS.SORT_CREATEDON,
              CONSTANTS.SORT_ORDER,
              ""
            )
            .then(() => {
              const propertyDropdownList: any[] = [];
              const propertyCodeIdDropdownList: any[] = [];
              this._propertyDropdownList.forEach(
                (element: IPropertyViewData) => {
                  propertyDropdownList.push({
                    label: element.name,
                    value: element.id,
                  });
                  propertyCodeIdDropdownList.push({
                    label: String(element.customId),
                    value: element.id,
                  });
                }
              );

              this.setState(
                {
                  propertyDropdownList,
                  propertyCodeIdDropdownList,
                  isCalculated: true,
                },
                () => {
                  propertyAttributeActions
                    .getAll()
                    .then(() => {
                      const propertyAttributeDropdownList: any[] = [];
                      this._propertyAttributeDropdownList.forEach(
                        (element: IPropertyAttribute) => {
                          propertyAttributeDropdownList.push({
                            label: element.name,
                            value: element.id,
                          });
                        }
                      );

                      this.setState(
                        {
                          propertyAttributeDropdownList,
                        },
                        () => this.forceUpdate()
                      );
                      this.validate();
                    })
                    .catch((error) => {
                      triggerNotifications
                        .errors(error.message, error.data)
                        .then();
                    });
                }
              );
            })
            .catch((error) => {
              triggerNotifications.errors(error.message, error.data).then();
            });
        } else {
          triggerNotifications.error("Invalid Formula").then();
        }
      })
      .catch((error: any) => {
        triggerNotifications.error("Invalid Formula").then();
      });
  };

  codeChangeHandler = (val: any) => {
    this.setState({
      selectedCodeId: val,
    });
  };

  propertyChangeHandler = (value: any, index: number) => {
    const formulaVariables = this.state.propertyFormData.formulaVariables;
    let code
    if(value.length !== 0){
      code = this.state.propertyCodeIdDropdownList.find(
        (x) => x.value === value[0].value
      );
    }
    formulaVariables[index].propertyId = value && value.length !== 0 ? value[0].value : "";
    formulaVariables[index].property = value && value.length !== 0 ? value : [];
    formulaVariables[index].codeId = code ? code.label : "";
    this.setState(
      {
        selectedProperty: value,
        propertyFormData: { ...this.state.propertyFormData, formulaVariables },
      },

      () => this.validate()
    );
  };

  propertyAttributeChangeHandler = (value: any, index: number) => {
    const formulaVariables = this.state.propertyFormData.formulaVariables;
    formulaVariables[index].propertyAttributeId = value && value.length !== 0 ? value[0].value : "";
    formulaVariables[index].propertyAttribute = value && value.length !== 0 ? value : [];
    this.setState(
      {
        selectedPropertyAttribute: value,
        propertyFormData: { ...this.state.propertyFormData, formulaVariables },
      },
      () => this.validate()
    );
  };

  validate(): void {
    if (
      !this.state.customIdError &&
      !this.state.nameError &&
      this.state.propertyFormData.customId &&
      this.state.propertyFormData.name &&
      this.state.propertyFormData.name.length > 1 &&
      this.state.propertyFormData.typeId &&
      this.state.propertyFormData.typeId !== CONSTANTS.DefaultGuid &&
      this._validDecimal
    ) {
      if (
        this.state.propertyFormData.typeId === CONSTANTS.CALCULATEDID &&
        (this.state.propertyFormData.formula === "" ||
          (this.state.propertyFormData.formulaVariables &&
            this.state.propertyFormData.formulaVariables.length &&
            this.state.propertyFormData.formulaVariables.some(
              (el: any) => el.propertyId === "" || el.propertyAttributeId === ""
            )))
      ) {
        submitHeaderActions
          .update({
            moduleName: CONSTANTS.MODULE_PROPERTY,
            isSubmitDisabled: true,
          })
          .then();
      } else {
        submitHeaderActions
          .update({
            moduleName: CONSTANTS.MODULE_PROPERTY,
            isSubmitDisabled: false,
          })
          .then();
      }
    } else {
      submitHeaderActions
        .update({
          moduleName: CONSTANTS.MODULE_PROPERTY,
          isSubmitDisabled: true,
        })
        .then();
    }
  }

  public onSaveClick = () => {
    const tempName = this.state.propertyFormData.name
      .replace(/ +(?= )/g, "")
      .trim();
    this.setState(
      (prevState) => ({
        formLoading: true,
        propertyFormData: {
          ...prevState.propertyFormData,
          name: tempName,
        },
      }),
      () => {
        const data = new PropertyFormData(
          this.state.propertyFormData.isEditMode,
          this.state.propertyFormData.requestId,
          this.state.propertyFormData.id,
          this.state.propertyFormData.customId,
          this.state.propertyFormData.name,
          this.state.propertyFormData.type,
          this.state.propertyFormData.typeId,
          this.state.propertyFormData.unit,
          this.state.propertyFormData.decimals,
          this.state.propertyFormData.description,
          this.state.propertyFormData.formula,
          [],
          this.state.propertyFormData.formulaVariables,
          this.state.propertyFormData.formulaDetails
        );

        propertyActions
          .put(data)
          .then(() => {
            this.setState(
              {
                formLoading: false,
              },
              () => {
                triggerNotifications.success(this._messages);
                setTimeout(() => {
                  history.push(CONSTANTS.PROPERTY_INDEX_URL, {
                    isReloadFirst: this._isReload,
                    id: this._id,
                  });
                }, CONSTANTS.NOTIFICATION_TIMEOUT);
              }
            );
          })
          .catch((error) => {
            this.setState(
              {
                formLoading: false,
              },
              () =>
                triggerNotifications.errors(error.message, error.data).then()
            );
          });
      }
    );
  };

  public onCreateClick = () => {
    const tempName = this.state.propertyFormData.name
      .replace(/ +(?= )/g, "")
      .trim();
    this.setState(
      (prevState) => ({
        formLoading: true,
        propertyFormData: {
          ...prevState.propertyFormData,
          name: tempName,
        },
      }),
      () => {
        const data = new PropertyFormData(
          this.state.propertyFormData.isEditMode,
          this.state.propertyFormData.requestId,
          this.state.propertyFormData.id,
          this.state.propertyFormData.customId,
          this.state.propertyFormData.name,
          this.state.propertyFormData.type,
          this.state.propertyFormData.typeId,
          this.state.propertyFormData.unit,
          this.state.propertyFormData.decimals,
          this.state.propertyFormData.description,
          this.state.propertyFormData.formula,
          [],
          this.state.propertyFormData.formulaVariables,
          this.state.propertyFormData.formulaDetails
        );

        propertyActions
          .post(data)
          .then(() => {
            this.setState(
              {
                formLoading: false,
              },
              () => {
                triggerNotifications.success(this._messages);
                setTimeout(() => {
                  history.push(CONSTANTS.PROPERTY_INDEX_URL, {
                    isReloadFirst: this._isReload,
                    id: this._id,
                  });
                }, CONSTANTS.NOTIFICATION_TIMEOUT);
              }
            );
          })
          .catch((error) => {
            this.setState(
              {
                formLoading: false,
              },
              () =>
                triggerNotifications.errors(error.message, error.data).then()
            );
          });
      }
    );
  };

  private idValidator = (value: string) => {
    if (value.trim() && /^\d+$/.test(value)) {
      this._validId = true;
      return { valid: true, text: value };
    }
    this._validId = false;
    return { valid: false, text: value };
  };

  private nameValidator = (value: string) => {
    if (value.trim() && /^[a-zA-Z0-9]*$/g.test(value)) {
      this._validName = true;
      return { valid: true, text: "VALID " };
    }
    this._validName = false;
    return { valid: false, text: "IN VAL" };
  };

  private decimalValidator = (value: string) => {
    if (/^-?\d*\.?\d*$/.test(value)) {
      this._validDecimal = true;
      return { valid: true, text: value };
    }
    this._validDecimal = false;
    return { valid: false, text: value };
  };

  onCancelClick = () => {
    history.push(CONSTANTS.PROPERTY_INDEX_URL, {
      isReloadFirst: this._isReload,
      id: this._id,
    });
  };

  public render() {
    return (
      <Translation>
        {(t) => (
          <div className="page-scroll">
            <div className="layout-container">
              <SubmitHeader
                name={t(CONSTANTS.MODULE_PROPERTY)}
                link={CONSTANTS.PATH_PROPERTY}
                isEdit={this.state.propertyFormData?.isEditMode}
                onSaveClick={this.onSaveClick}
                onCreateClick={this.onCreateClick}
                onCancelClick={this.onCancelClick}
                isLoading={this.state.formLoading}
              />
              <div className="mt-3">
                <div className="col-6 no-padding float-left">
                  <div className="box-1">
                    <div className="box-circle">
                      <p className="box-circle-text"> 1 </p>
                    </div>
                    <div className="ml-4">
                      <p className="sidebar-main-title font-weight-bold ml-2">
                        {t(
                          CONSTANTS.MENU_PROPERTY +
                            " " +
                            CONSTANTS.TITLE_TESTOVERVIEW_DETAILS
                        )}
                      </p>
                    </div>
                    <hr className="hr-line" />

                    <div className="row mt-2">
                      <div className="col-sm-9 col-md">
                        <Input
                          inputAttributes={{ autoFocus: "true" }}
                          maxLength={8}
                          dataType="text"
                          placeholder={t(CONSTANTS.LABEL_PROPERTYID)}
                          label={t(CONSTANTS.LABEL_PROPERTYID)}
                          required={true}
                          className={
                            this.state.customIdError
                              ? "error-code mt-2 w-50"
                              : "mt-2 w-50"
                          }
                          value={String(this.state.propertyFormData?.customId)}
                          onValueChange={this.setCustomId}
                          showValidationBarWhenInvalid={
                            this.state.customIdError ? true : false
                          }
                          description={
                            this.state.customIdError
                              ? this.state.propertyFormData.customId.length
                                ? t(CONSTANTS.PROPERTY_ID_VALIDATION_ERROR)
                                : t(CONSTANTS.FIELD_EMPTY_ERROR)
                              : ""
                          }
                        />
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-sm col-md">
                        <Input
                          dataType="text"
                          placeholder={t(CONSTANTS.LABLE_NAME)}
                          label={t(CONSTANTS.LABLE_NAME)}
                          required={true}
                          className={
                            this.state.nameError
                              ? "error-code mt-2 w-50"
                              : "mt-2 w-50"
                          }
                          value={this.state.propertyFormData?.name}
                          onValueChange={this.setName}
                          maxLength={250}
                          showValidationBarWhenInvalid={
                            this.state.nameError ? true : false
                          }
                          description={
                            this.state.nameError
                              ? this.state.propertyFormData.name.length
                                ? t(CONSTANTS.NAME_VALIDATION_ERROR)
                                : t(CONSTANTS.FIELD_EMPTY_ERROR)
                              : ""
                          }
                        />
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-sm col-md">
                        <Input
                          dataType="textarea"
                          label={t(CONSTANTS.LABEL_DESCRIPTION)}
                          placeholder={t(CONSTANTS.LABEL_DESCRIPTION)}
                          value={this.state.propertyFormData?.description}
                          onValueChange={this.setDescription}
                          inputAttributes={{ rows: "4" }}
                          className="mt-2 h-25"
                          resizable={false}
                          maxLength={200}
                        />
                      </div>
                    </div>
                    <div className="p-3">
                      {t(CONSTANTS.DESCRIPTION_BELOW_INFO)}
                    </div>
                  </div>
                </div>

                <div className="col-6 no-padding float-left">
                  <div className="box-2 ml-3">
                    <div className="box-circle">
                      <p className="box-circle-text"> 2 </p>
                    </div>
                    <div className="ml-4">
                      <p className="sidebar-main-title font-weight-bold ml-2">
                        {t(CONSTANTS.LABLE_ADDITIONAL_INFORMATION)}
                      </p>
                    </div>
                    <hr className="hr-line" />

                    <div className="row mt-3">
                      <div className="col-sm-6 col-md-6">
                        <Dropdown
                          label={t(CONSTANTS.LABEL_TYPE)}
                          allowAdd={false}
                          required={true}
                          clearable={false}
                          placeholder={t(CONSTANTS.NO_PROPERTY_TYPE_SELECTED)}
                          searchable={true}
                          value={this.state.selectedPropertyType}
                          onChange={this.typeChangeHandler}
                        >
                          {this.state.propertyTypesdropdownList.map(
                            (o: any, index) => (
                              <DropdownOption
                                key={index}
                                label={o.label}
                                value={o.value}
                              />
                            )
                          )}
                        </Dropdown>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-sm col-md">
                        <Input
                          dataType="text"
                          label={t(CONSTANTS.LABEL_UNIT)}
                          placeholder={t(CONSTANTS.LABEL_UNIT)}
                          value={this.state.propertyFormData?.unit}
                          onValueChange={this.setUnits}
                          className="mt-2 w-25"
                          maxLength={10}
                        />
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-sm col-md">
                        <Input
                          className="mt-2 w-25"
                          dataType="text"
                          label={t(CONSTANTS.LABEL_DECIMALS)}
                          placeholder={t(CONSTANTS.LABEL_DECIMALS)}
                          value={String(this.state.propertyFormData?.decimals)}
                          onValueChange={this.setDecimals}
                          maxLength={1}
                          validator={() =>
                            this.decimalValidator(
                              this.state.propertyFormData?.decimals
                            )
                          }
                        />
                      </div>
                    </div>
                    {this.state.isFormula ? (
                      <React.Fragment>
                        <div className="row mt-2">
                          <div className="col-sm-6 col-md-6">
                            <Input
                              placeholder="[a]+[b]"
                              dataType="textarea"
                              required={true}
                              label={t(CONSTANTS.FORMULA)}
                              value={String(
                                this.state.propertyFormData?.formula
                              )}
                              onValueChange={this.setFormula}
                              className="mt-2"
                              resizable={false}
                            />
                          </div>
                          <div className="col-sm-3 col-md-3 mt-4">
                            <Button
                              type="normal"
                              onClick={this.onCalculatedSaveClick}
                              text={t(CONSTANTS.BUTTON_SAVE)}
                              className="mt-1"
                              style={{ background: "black", color: "white" }}
                            />
                          </div>
                        </div>
                        <div className="ml-3">
                          {t(CONSTANTS.FORMULA_BELOW_INFO)}
                        </div>
                      </React.Fragment>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="clearfix" />

              {/* Calculated Part  */}
              {this.state.isCalculated && this.state.isFormula ? (
                <div className="box-1 create_property">
                  <div>
                    <div className="box-circle">
                      <p className="box-circle-text"> 3 </p>
                    </div>
                    <div className="ml-4">
                      <p className="sidebar-main-title font-weight-bold ml-2">
                        {t(CONSTANTS.CALCULATED_PROPERTY_DEF)}
                      </p>
                    </div>
                  </div>

                  <hr className="hr-line mt-3" />
                  <div className="head p-3">
                    <div className="sidebar-main-title mt-1">
                      {t(CONSTANTS.INPUT_DEFINITION)}
                    </div>
                    <div>
                      <table className="table tbl-edit">
                        <thead>
                          <tr>
                            <td
                              className="table-title sidebar-main-title text-uppercase px-3"
                              style={{ width: "10%", background: "#f5f5f5" }}
                            >
                              {t(CONSTANTS.LABEL_VARIABLE)}{" "}
                              <span className="required_header">*</span>
                            </td>
                            <td
                              className="table-title sidebar-main-title text-uppercase"
                              style={{ width: "10%", background: "#f5f5f5" }}
                            >
                              {t(CONSTANTS.MENU_PROPERTY)}{" "}
                              <span className="required_header">*</span>
                            </td>
                            <td
                              className="table-title sidebar-main-title text-uppercase"
                              style={{ width: "10%", background: "#f5f5f5" }}
                            >
                              {t(CONSTANTS.LABEL_PROPERTYID)}
                            </td>
                            <td
                              className="table-title sidebar-main-title text-uppercase"
                              style={{ width: "10%", background: "#f5f5f5" }}
                            >
                              {t(CONSTANTS.LABEL_PROPERTY_ATTRIBUTE)}{" "}
                              <span className="required_header">*</span>
                            </td>
                          </tr>
                          {this.state.propertyFormData?.formulaVariables.map(
                            (item, index) => {
                              return (
                                <tr key={index} style={{ height: 50 }}>
                                  <td>
                                    <span className="w-75 pl-2 text-center abb-main-font">
                                      {item.variable}
                                    </span>
                                  </td>

                                  <td>
                                    <Dropdown
                                      className="w-75"
                                      allowAdd={false}
                                      clearable={true}
                                      placeholder={t(
                                        CONSTANTS.LABEL_PICK +
                                          " " +
                                          CONSTANTS.MENU_PROPERTY
                                      )}
                                      searchable={true}
                                      value={item.property}
                                      onChange={(value) =>
                                        this.propertyChangeHandler(value, index)
                                      }
                                    >
                                      {this.state.propertyDropdownList.map(
                                        (o: any, index: number) => (
                                          <DropdownOption
                                            key={index}
                                            value={o.value}
                                            label={o.label}
                                          />
                                        )
                                      )}
                                    </Dropdown>
                                  </td>

                                  <td>
                                    <span className="w-75 pl-2 abb-main-font">
                                      {item.codeId}
                                    </span>
                                  </td>
                                  <td>
                                    <Dropdown
                                      className="w-75"
                                      allowAdd={false}
                                      placeholder={t(
                                        CONSTANTS.LABEL_PICK +
                                          " " +
                                          CONSTANTS.MENU_PROPERTY +
                                          " " +
                                          CONSTANTS.MENU_ATTRIBUTE
                                      )}
                                      clearable={true}
                                      searchable={true}
                                      value={item.propertyAttribute}
                                      onChange={(value) =>
                                        this.propertyAttributeChangeHandler(
                                          value,
                                          index
                                        )
                                      }
                                    >
                                      {this.state.propertyAttributeDropdownList.map(
                                        (o: any, index: number) => (
                                          <DropdownOption
                                            key={index}
                                            label={o.label}
                                            value={o.value}
                                          />
                                        )
                                      )}
                                    </Dropdown>
                                  </td>
                                </tr>
                              );
                            }
                          )}
                        </thead>
                      </table>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

export default withRouter(Form);
